<template>
  <v-card flat tile class="">
    <v-card-text class="pt-3 pb-3">
      <v-select
            v-model="selectedSurvey"
            :items="getSurvey"
            item-text="title"
            item-value="id"
            :label="$t('poll.lblSelectSurvey')"
            return-object
            outlined
            solo
            dense
            :menu-props="{ bottom: true, offsetY: true }"
            @change="handleChange"
            hide-details
            style="max-width: 800px;"
          >
            <template slot="no-data">
              <span class="ml-3 subtitle-2"
                ><strong>{{ $t("poll.msgNoResponses") }}</strong></span
              >
            </template>
          </v-select>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
import SignalRMixin from "../../mixin/SignalRMixin";
export default {
  name: "SurveySelector",
  mixins: [SignalRMixin],
  data() {
    return {
      selectedSurvey: this.$route.params.id
    };
  },
  async mounted(){
    await this.getSurveyList();
    if(this.getSelectorSurvey){
      this.selectedSurvey = this.getSelectorSurvey
    }
    this.signalRInit(`surveys_${this.selectedTenant}`);
  },
  computed: {
    ...mapState({
      pollSurveyQuestions: (state) => state.poll.pollSurveyQuestions,
      getSelectorSurvey: (state) => state.poll.selectorSurvey,
    }),
    getSurvey() {
    return this.pollSurveyQuestions
      .filter(item => item.type === "survey")
      .sort((a, b) => new Date(b.startDate) - new Date(a.startDate))
      .map(({ id, title }) => ({ id, title }));
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
  },
  methods: {
    ...mapActions({
      getSurveyList: "poll/getSurveyList",
      surveySelector: "poll/setSurveySelector",
    }),
    handleChange(value) {
      this.surveySelector(value.id)
    },
    async signalRInit(target) {
      this.signalConnection.on(target, async (message) => {
        const result = JSON.parse(message);
        try {
          if (result && this.$security.checkUserAccess("ViewSurveyPolls")) {
            await this.getSurveyList();
            this.selectedSurvey = this.$route.params.id
            this.surveySelector(this.$route.params.id)
          }
        } catch (error) {
          console.log(error, "API error");
        }
      });
      if (
        this.signalConnection.connectionState.toLowerCase() === "disconnected"
      ) {
        this.signalConnection.start().catch();
      }
    },
  },
};
</script>
